import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const EditCtx = createContext({ nav: [] });
export const EDIT_ROLES = ["admin", "manager", "marketing"];
export const canEdit = (u) => Boolean(u && EDIT_ROLES.includes(u.role));

export function EditProvider({ children }) {
  const { user } = useAuth();
  const allowed = canEdit(user);
  const [flag, setFlag] = useState(sessionStorage.getItem("site_edit") === "1");
  const [preview, setPreview] = useState(false);
  const [nav, setNav] = useState([]);
  const editing = allowed && flag;
  const setEditing = (v) => { sessionStorage.setItem("site_edit", v ? "1" : "0"); setFlag(v); setPreview(false); };
  const loadNav = useCallback(() => api.get("/public/nav", { params: editing ? { draft: true } : {} }).then((r) => setNav(r.data)).catch(() => {}), [editing]);
  useEffect(() => { loadNav(); }, [loadNav]);
  return <EditCtx.Provider value={{ allowed, editing, preview, setPreview, setEditing, nav, loadNav }}>{children}</EditCtx.Provider>;
}

export const useEdit = () => useContext(EditCtx);

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/cms/images", fd);
  return data.url;
}

export const isInternal = (l) => typeof l === "string" && l.startsWith("/");
